import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as  R from 'ramda';
import { useAppDispatch, useAppSelector } from '../../../../../../../hooks/hooks';
import { orders } from '../../../../../../../redux/orders/action';
import ShipmentComponent from '../components/shipment.component';
import { selectTransportersListItems } from '../../../../../../../redux/transporters/selector';
import { agents } from '../../../../../../../redux/agents/action';
import { selectOrdersQueryItems } from '../../../../../../../redux/orders/selector';
import { selectAgentsListItems } from '../../../../../../../redux/agents/selector';
import PageLoader from '../../../../../../../components/PageLoader';
import { onMessage } from 'firebase/messaging';
import { messaging } from '../../../../../../../service/firebase';
import { transporters } from '../../../../../../../redux/transporters/action';
import { selectCurrent } from '../../../../../../../redux/settings/selectors';
import { settings } from '../../../../../../../redux/settings/actions';
import { deepCopy } from '../../../../../../../common/services/common.service';
import UploadFiles from '../../../../../../../models/UploadFile';
import { selectListItems } from '../../../../../../../redux/library/selector';

let currentChange: any = {}
const CustomerOrder = () => {
  const { getUploadFiles } = useAppSelector(selectCurrent)
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const libraryData = useSelector(selectListItems)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const orderQuery = useSelector(selectOrdersQueryItems)
  const transporterListItems = useSelector(selectTransportersListItems)
  const transportAgentListItems = useSelector(selectAgentsListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [location, setLocation] = useState<any>([])
  const [payload, setPayload] = useState<any>([{ notification: { title: '', body: '' } }])
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const [
    selectShipping,
    setSelectShipping
  ] = useState<any>([])
  const [
    mediaFiles,
    setMediaFiles
  ] = useState<any>([])
  const [
    imageIndex,
    setImageIndex
  ] = useState<any>([])
  const [
    openFile,
    setOpenFile
  ] = useState<any>([]);

  const fetchorderById = () => {
    dispatch(orders.query({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/shipments/query`, entity: 'orders', jsonData: {

        Records: [
          {
            context: {},
            Message: {
              Id: parmas?.id
            }
          }
        ]

      }
    })).then(() => {
      setIsQuery(true)
    }).then(() => {
      setIsLoading(false)
    })
  }
  const handleInnerFormChange = (event: any, field: string) => {
    setSelectShipping({ ...selectShipping, [field]: event });
  }

  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },

      { field: 'ItemName', headerName: 'Item Name' },
      { field: 'Quantity', headerName: 'Quantity' },
    ]);
  }
  const getTransportersName = (transporterId: any) => {
    const TransporterName = R.find(
      (transporter: any) => parseInt(
        transporter.Id,
        10
      ) === parseInt(
        transporterId,
        10
      ),
      transporterListItems.result.items
    )
    return TransporterName ? TransporterName.Name : ''
  }

  useEffect(
    () => {
      dispatch(transporters.list({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/transporters/list`, entity: 'transporters', jsonData: {

        }
      })).then(() => {
        dispatch(agents.list({
          url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/transport-agents/list`, entity: 'agents', jsonData: {

          }
        }))
      }).then(() => {
        if (parmas?.id > 0) {
          createColumnDefs()
          fetchorderById()
          setIsLoading(false)
        } else {
          setIsLoading(false)
        }
      })

      new Promise((resolve) => onMessage(messaging, (payload: any) => {
        const latLongData = _.split(payload?.data?.Location, ',');
        console.log(latLongData, 'latLongDatapayload')
        setPayload({ notification: { title: '', body: payload?.data?.Location } })
        console.log(payload, 'payload')
        setLocation(
          {
            Latitude: latLongData[0],
            Longitude: latLongData[1]
          }

        )
        resolve(payload)
      }))

    },
    []
  )
  useEffect(
    () => {

      if (isQuery) {
        setSelectShipping(orderQuery?.result?.items?.Message)
        const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: orderQuery?.result?.items?.Message?.fulfillments[0]?.EWayBill?.MediaFiles });
        setMediaFiles(localSelectedMedia)
      }
    },
    [isQuery]
  )

  const addNewMediaFilesRow = ({ selectedMediaFilesArg }: any) => {
    const localSelectedmedia = deepCopy(selectedMediaFilesArg)
    const newsSelectedMedia = {
      Id: 0,
      FileTypeId: 0,
      OwnerId: parmas?.id,
      OwnerType: 'shipping',
      OwnerTypeId: 1007,
      FileMappingURL: ''
    }
    if (localSelectedmedia.length === 0 ||
      localSelectedmedia[localSelectedmedia?.length - 1]?.FileTypeId !== 0
    ) {
      localSelectedmedia?.push(newsSelectedMedia)
    }

    return localSelectedmedia
  }
  const setMediaInfo = async () => {
    let localSelectedMedia = deepCopy(mediaFiles)
    localSelectedMedia.splice(
      currentChange.idx,
      1,
      { ...localSelectedMedia[currentChange.idx] }
    );
    localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: localSelectedMedia });
    currentChange.field = 'FileTypeIdDONE'
    setMediaFiles(localSelectedMedia)
  }
  const changeImage = (idx: number, templateField: any, fileType: any) => {
    setImageIndex(idx)
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenFile({
      currentFileSrc: mediaFiles[idx][templateField],
      folder: 'shipping',
      type: fileType
    })
  }
  const handleSubmit = (data: any) => {

    mediaFiles[imageIndex].FileMappingURL = data

  }
  const handleClose = () => {
    dispatch(settings.set({ getUploadFiles: 'close' }))

  }
  const handleFormMediaItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(mediaFiles);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setMediaFiles(items);
  }

  // useEffect(
  //   () => {
  //     if (currentChange.field === 'FileTypeId') {
  //       setMediaInfo()
  //     }
  //   },
  //   [mediaFiles]
  // )

  const back = () => {
    navigate('/customer/logistics/transport/shipments')
  }

  return (
    <>
      {getUploadFiles == 'open' && <UploadFiles currentFilesSrc={openFile?.currentFileSrc}
        folder={openFile?.folder}
        handleClose={handleClose}
        handleFilesSubmit={handleSubmit}
        type={openFile?.type}
        ownerId={parmas?.id}
      />}
      {isLoading ? <PageLoader /> :

        <ShipmentComponent
          mediaFiles={mediaFiles}
          handleFormMediaItemChange={handleFormMediaItemChange}
          fileTypes={libraryData?.result?.FileType}
          changeImage={changeImage}
          rowData={selectShipping.ShipmentItems}
          columnDefs={columnDefs}
          selectShipping={selectShipping}
          getTransportersName={getTransportersName}
          handleInnerFormChange={handleInnerFormChange}
          transportAgents={transportAgentListItems.result.items}
          back={back}
          location={location}
        />}
    </>
  )

}

export default CustomerOrder;